// Module
var code = "<div class=\"iia-incoming-item iia-drawer-divider\"> <div class=\"iia-location\">{{location-name}}</div> <div>{{titleText}}</div> </div>";
// Exports
module.exports = code;